import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=0f77fb5f"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"
import style0 from "./Sms.vue?vue&type=style&index=0&id=0f77fb5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports